import React from 'react';
import { Form, FormField } from '../../../shared/components/form_components/form';
import { FormGroup } from '../../../shared/components/form_components/group';
import { InputForm } from '../../../shared/components/form_components/input';
import { InputToggle } from '../../../shared/components/form_components/toggle';
import { Container } from './styles';

interface Props {
  oferta?: Partial<FormOferta>;
  onSubmit: (oferta: FormOferta) => void;
  onCancel?: () => void;
}

interface FormOferta {
  id_curso: number;
  id_oferta?: number;
  num_oferta: number;
  num_ano: number;
  num_semestre: number;
  dsc_email_assistente?: string | null;
  dat_inicio?: string | null;
  dat_fim?: string | null;
  ativa: boolean;
}

const FormularioOferta: React.FC<Props> = (props) => {
  const fields: FormField[] = [
    {
      name: 'id_oferta',
      label: 'Id da oferta',
      type: 'number',
      value: props.oferta?.id_oferta,
      required: true,
      disabled: true,
      component: InputForm,
    },
    {
      name: 'id_curso',
      label: 'Id curso',
      type: 'number',
      value: props.oferta?.id_curso,
      required: true,
      disabled: true,
      component: InputForm,
    },
    {
      name: 'group_periodo_num_oferta',
      type: 'group',
      sub_fields: [
        {
          name: 'num_ano',
          label: 'N° ano',
          type: 'number',
          defaultValue: props.oferta?.num_ano,
          required: true,
          component: InputForm,
        },
        {
          name: 'num_semestre',
          label: 'N° semestre',
          type: 'number',
          defaultValue: props.oferta?.num_semestre,
          required: true,
          component: InputForm,
        },
      ],
      component: FormGroup,
    },
    {
      name: 'group_periodo_num_oferta',
      type: 'group',
      sub_fields: [
        {
          name: 'num_oferta',
          label: 'N° oferta',
          type: 'number',
          defaultValue: props.oferta?.num_oferta,
          required: true,
          component: InputForm,
        },
        {
          name: 'ativa',
          label: 'Ativa',
          id: 'oferta_ativa',
          type: 'checkbox',
          defaultChecked: props.oferta?.ativa,
          required: true,
          component: InputToggle,
        },
      ],
      component: FormGroup,
    },
    {
      name: 'dsc_email_assistente',
      label: 'E-mail do Assistente',
      type: 'text',
      defaultValue: props.oferta?.dsc_email_assistente || '',
      required: false,
      component: InputForm,
    },
    {
      name: 'group_periodo_datas',
      type: 'group',
      sub_fields: [
        {
          name: 'dat_inicio',
          label: 'Data de Início',
          type: 'date',
          defaultValue: props.oferta?.dat_inicio ? new Date(props.oferta.dat_inicio).toISOString().split('T')[0] : '',
          required: false,
          component: InputForm,
        },
        {
          name: 'dat_fim',
          label: 'Data de Término',
          type: 'date',
          defaultValue: props.oferta?.dat_fim ? new Date(props.oferta.dat_fim).toISOString().split('T')[0] : '',
          required: false,
          component: InputForm,
        },
      ],
      component: FormGroup,
    },
  ];

  return (
    <Container>
      <Form
        fields={fields}
        form_name='oferta'
        is_edit={Boolean(props.oferta?.id_oferta)}
        onSubmit={props.onSubmit}
        onCancel={props.onCancel}
      />
    </Container>
  );
};

export { FormularioOferta };
export type { FormOferta };
